function appendQuerySymbol(url, queryParam) {
  if (!url || typeof url !== 'string') {
    return null;
  }

  if (!queryParam || typeof queryParam !== 'string') {
    return url;
  }

  try {
    const urlObj = new URL(url);
    if (urlObj.protocol !== 'http:' && urlObj.protocol !== 'https:') {
      return null;
    }
    const symbol = urlObj.searchParams.toString().length > 0 ? '&' : '?';
    return `${url}${symbol}${queryParam}`;
  } catch (err) {
    return null;
  }
}

export default appendQuerySymbol;
